// ─── Machines Directory Route ───
// /app/machines — issue #227: the dev-machine catalog (ADR 0025) grouped by
// client, at navigation level (machine CRUD stays in Settings → Máquinas).
// Visible to EVERY authenticated user (unconditional — same ruling as
// /app/clients); no route-level auth guard is needed here, AppLayout already
// gates authentication.

import { createFileRoute } from '@tanstack/react-router';
import { MachinesDirectoryPage } from '../../features/dev-machines/MachinesDirectoryPage';

export const Route = createFileRoute('/app/machines')({
  component: MachinesRoute,
});

// GHE #283 item 2 added a single-segment Breadcrumb here; GHE #452 removed it.
// The claim it was added under — "the one consistent place every route now shows
// 'where am I'" — was never true (it reached 4 of 14 in-app pages), and the lone
// segment read "Máquinas" directly above MachinesDirectoryPage's own "Máquinas"
// <h1>. A trail needs somewhere to have come from; this route is a top-level
// destination, so Breadcrumb now declines to render below 2 segments.
function MachinesRoute(): React.ReactElement {
  return <MachinesDirectoryPage />;
}
